export default __webpack_public_path__ + "static/media/shipping.537637b7.png";